import { render, staticRenderFns } from "./TeacherChatbot.vue?vue&type=template&id=1369e7c5&scoped=true"
import script from "./TeacherChatbot.vue?vue&type=script&lang=ts"
export * from "./TeacherChatbot.vue?vue&type=script&lang=ts"
import style0 from "./TeacherChatbot.vue?vue&type=style&index=0&id=1369e7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369e7c5",
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBadge,QDialog});
